import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { images } from 'app/constants/images';

import ErrorPageUI from './ErrorPageUI';

// Component Definition
const MaintenancePage: FC = () => {
  const { t } = useTranslation();

  return (
    <ErrorPageUI
      alt="Yield Sign"
      backgroundImage={images.yieldSign.full}
      backgroundImageLoader={images.yieldSign.compressed}
      heading={t('common:maintenancePage.heading', 'Maintenance')}
      subheading={t('common:maintenancePage.subheading',
        'We are undergoing a scheduled maintenance and will be back online shortly.')}
      withNavBar
    />
  );
};

export default MaintenancePage;
